import { Injectable } from '@angular/core';

import { ApiCommonService } from '@bases/services-api.base';
import { map, Observable } from 'rxjs';

import { ApiAlertError } from '@core/decorators/api-alert-error';
import { User, UserJson } from '@models/user.model';

@Injectable({
  providedIn: 'root'
})
export class UserApiService extends ApiCommonService<User, UserJson> {
  readonly resourceUrl = 'api/v1/users/me';

  fromJson(json: UserJson): User {
    return User.fromJson(json);
  }

  toJson(): UserJson {
    return null;
  }

  @ApiAlertError()
  getUser(): Observable<User> {
    return this.httpClient.get<UserJson>(this.resourceUrl).pipe(map((userJson: UserJson) => this.fromJson(userJson)));
  }
}
